<template>
  <section class="custom-wrapper">
    <!-- Listing Actions -->
    <div class="table-responsive">
      <div class="row custom-row">
        <div class="col-1">
          <button class="btn btn-primary btn-small mb-2" @click="addMatrixInfoLookup">Add</button>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-4">
              <z-select v-model="filter" label="Make" :options="vehicles" :inline="true" @change="refreshList" />
            </div>
            <div class="col-4">
              <div class="custom-show-checkbox">
                <input v-model="showInactive" type="checkbox" class="custom-checkbox" @change="refreshList" />
                <span class="ms-2">Show Inactive?</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 text-right">
          <div class="custom-right-align">
            <button class="btn btn-primary btn-sm" :disabled="isDownloading" @click="exportMatrixInfoLinks">
              <FontAwesomeIcon v-if="isDownloading" icon="fa-solid fa-spinner me-2" spin />
              Export ADAS Info Links
            </button>
            <button v-if="isReorder" class="btn btn-primary btn-sm ms-2" @click="renumberSort">
              <FontAwesomeIcon v-if="isRenumbering" icon="fa-solid fa-spinner me-2" spin />
              Re-number Sort
            </button>
          </div>
        </div>
      </div>
      <!-- Listing -->
      <div v-show="loading?.adasmatrixinfolookups" class="listingWrapper">
        <div class="custom-spinner">
          <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
        </div>
      </div>
      <div v-show="!loading?.adasmatrixinfolookups" class="listingWrapper">
        <z-table v-model="adasmatrixinfolookups" class="table table-bordered table-striped"
          :is-single-row-detail="false" sort-on="sort" sort-dir="asc" :columns="tableColumnsName"
          :is-header-fixed="true" @sort="setOrder">
          <template #tbody="props">
            <td class="custom-column-60">
              <a href="#" @click="editMatrixInfoLookup(props.row)">edit</a>
            </td>
            <td>{{ props.row.keywords }}</td>
            <td>{{ props.row.vehicleMake }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearStart }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearEnd }}</td>
            <td>{{ props.row.source }}</td>
            <td class="text-center">{{ props.row.sort }}</td>
            <td class="custom-column-60-center">
              {{ props.row.isInactive ? 'Y' : '' }}
            </td>
          </template>
          <template #empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <!-- Dialogs -->
    <dialog-matrix-info-lookup v-model="actionMatrix" @closing="closeModal" @saved="savedMatrixInfoLookup" />
    <confirm-delete v-model="actionDelete" :confirm-title="confirmTitle" :confirm-action="confirmAction"
      :confirm-question="confirmQuestion" @closing="closeModal" @proceed="performDelete" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import ZTable from '@/components/utilities/elements/Table.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogMatrixInfoLookup from './dialog-matrix-info-lookup.vue'
export default {
  name: 'MatrixInfo',
  components: {
    ZTable,
    ZSelect,
    ConfirmDelete,
    DialogMatrixInfoLookup,
    FontAwesomeIcon
  },
  props: {
    source: {
      type: Number,
      default: 2
    },
    value: Object
  },
  data() {
    return {
      actionMatrix: null,
      actionDelete: null,
      confirmTitle: 'Delete this Matrix Info Lookup?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this Matrix Info Lookup?',
      showInactive: false,
      filter: '-9999',
      orderBy: 'sort',
      sortBy: 'asc',
      isDownloading: false,
      isRenumbering: false
    }
  },
  async mounted() {
    this.filter = '-9999'
    this.orderBy = 'sort'
    this.sortBy = 'asc'
    this.showInactive = false
    console.log('Matrix Info Lookup Mounted', this.value)
    if (this.value) {
      if (this.value.vehicleMake) {
        this.filter = this.value.vehicleMake
      }
    }
    await this.getList()
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'lookups', 'adasmatrix', 'adasmatrixinfolookups', 'matrixAdasInfo']),
    tableColumnsName() {
      return [
        {
          field: 'adasChecklistMatrixInfoLookup',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'keywords',
          label: 'Description',
          sortable: true
        },
        {
          field: 'vehicleMake',
          label: 'Make',
          sortable: true
        },
        {
          field: 'yearStart',
          label: 'Yr Start',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'yearEnd',
          label: 'Yr End',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'source',
          label: 'Type',
          sortable: true
        },
        {
          field: 'sort',
          label: 'Sort',
          sortable: true,
          class: 'custom-column-100 text-center'
        },
        {
          field: 'isInactive',
          label: 'Inactive?',
          sortable: false,
          class: 'custom-column-60-center'
        }
      ]
    },
    vehicles() {
      let _data = []
      _data.push({
        id: -9999,
        name: 'all',
        value: -9999
      })
      if (this.lookups['VehicleMake']) {
        this.lookups['VehicleMake'].forEach((element) => {
          _data.push(element)
        })
      }
      return _data
    },
    isReorder() {
      return this.filter !== null && this.filter !== '-9999'
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, [
      'getAdasMatrixInfoLookups',
      'getAdasMatrixInfoLookup',
      'initAdasMatrixInfoLookup',
      'updateAdasMatrixInfoLookup',
      'deleteAdasMatrixInfoLookup',
      'checklistMatrixAdasInfoExport',
      'reorderAdasMatrixInfoLookups'
    ]),
    closeModal() {
      this.actionMatrix = null
      this.actionDelete = null
    },
    refreshList() {
      this.getList()
    },
    setOrder(column, sortBy) {
      this.orderBy = column.field
      this.sortBy = sortBy
      this.getList()
    },
    async getList() {
      let options = {
        id: this.source === 2 ? this.adasmatrix.adasChecklistMatrix : null,
        orderBy: this.orderBy,
        sortBy: this.sortBy,
        type: this.source,
        filter: this.filter === '-9999' ? null : this.filter,
        status: this.showInactive ? 'Inactive' : ''
      }
      console.log('Refreshing ADAS Matrix Info Lookup', options)
      await this.getAdasMatrixInfoLookups(options)
    },
    addMatrixInfoLookup() {
      this.initAdasMatrixInfoLookup()
      this.updateAdasMatrixInfoLookup({
        name: 'adasChecklistMatrix',
        value: this.source === 2 ? this.adasmatrix.adasChecklistMatrix : null
      })
      this.updateAdasMatrixInfoLookup({
        name: 'lookupType',
        value: this.source
      })
      this.updateAdasMatrixInfoLookup({
        name: 'source',
        value: this.source
      })
      this.actionMatrix = {
        type: 'ADD',
        subtitle: this.source !== 4 ? this.adasmatrix.matrixItem : null
      }
    },
    async editMatrixInfoLookup(matrix) {
      console.log('Editing Matrix Info Lookup', {
        matrix: matrix,
        source: this.source
      })
      this.getAdasMatrixInfoLookup(matrix.adasChecklistMatrixInfoLookup)
      this.actionMatrix = {
        type: 'EDIT',
        subtitle: this.source !== 4 ? this.adasmatrix.matrixItem : null
      }
    },
    async savedMatrixInfoLookup() {
      await this.getList()
      this.closeModal()
    },
    confirmDelete(matrix) {
      this.actionDelete = matrix
    },
    async performDelete(matrix) {
      this.actionDelete = null
      console.log('Deleting Matrix Info Lookup', matrix)
      await this.deleteAdasMatrixInfoLookup(matrix.adasChecklistMatrixInfoLookup)
      await this.getList()
    },
    vehicleMake() {
      let _id = null
      if (this.value) {
        _id = this.value.vehicleMake
      }
      return _id
    },
    async exportMatrixInfoLinks() {
      console.log('Exporting ADAS Info Links')
      this.isDownloading = true
      let vehicleMake = null
      if (this.filter !== null) {
        if (parseInt(this.filter) !== -9999) {
          vehicleMake = parseInt(this.filter)
        }
      }
      await this.checklistMatrixAdasInfoExport({
        source: this.source,
        isInactive: this.showInactive,
        vehicleMake: vehicleMake
      })
      if (this.matrixAdasInfo) {
        var blob = new Blob([this.matrixAdasInfo], { type: 'text/csv' })
        var link = document.createElement('a')
        var now = moment().format('MMDDYYYY')
        if (window.URL.createObjectURL) {
          link.href = window.URL.createObjectURL(blob)
          link.download = `ADAS MAP ADAS Info Links ${now}.csv`
          link.click()
        } else {
          this.message = 'Refresh your browser to generate this download.'
        }
      }
      this.isDownloading = false
    },
    async renumberSort() {
      if (this.filter !== null) {
        if (this.filter !== '-9999') {
          this.isRenumbering = true
          console.log('Re-numbering Sort', parseInt(this.filter))
          await this.reorderAdasMatrixInfoLookups({
            vehicleMake: parseInt(this.filter)
          })
          this.isRenumbering = false
          await this.getList()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}

.custom-row {
  margin: 0 !important;
}

.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}

.listingWrapper {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 600px;
  width: 100%;
}

.custom-show-checkbox {
  position: relative;
  top: 5px;
}

.custom-right-align {
  text-align: right;
}
</style>
